// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__1O7Jy","code":"NotFound_code__soeT9","title":"NotFound_title__bL9rT","sub":"NotFound_sub__S12tx","btn":"NotFound_btn__bjZb2"};